export default "__VITE_ASSET__DeDilImv__"